import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ReactNode } from "react";

import { NvLucideCloseIcon } from "@/components/navigator/nv-icons-mypage";

// My Page 팝업 틀 (Figma ver.7 "Dialog / 회원 탈퇴" 847:47745): NvModal과 같은 모양(dim 45% · 흰 카드 r12 · 안쪽 28 · 간격 16)에
// 닫기 아이콘만 06 기준(Lucide x · 24px, 제안 06 · 637:593)으로 바꾼 것이에요. 공용 NvModal은 그대로 둬요.
export function MyPageModal({
  open,
  onOpenChange,
  title,
  width = 480,
  footer,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  width?: number;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-[rgb(26_28_33_/_0.45)]" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          style={{ maxWidth: width }}
          className="fixed left-1/2 top-1/2 z-50 flex max-h-[calc(100vh-48px)] w-[calc(100vw-32px)] -translate-x-1/2 -translate-y-1/2 flex-col gap-4 rounded-nv-card bg-nv-surface p-7 font-sans focus:outline-none"
        >
          <div className="flex items-center justify-between">
            <DialogPrimitive.Title className="text-[18px] font-medium leading-[22px] text-nv-text-primary">{title}</DialogPrimitive.Title>
            <DialogPrimitive.Close
              aria-label="닫기"
              className="rounded-nv-pill text-nv-text-primary hover:opacity-70 focus:outline-none focus-visible:ring-2 focus-visible:ring-nv-brand"
            >
              <NvLucideCloseIcon size={24} />
            </DialogPrimitive.Close>
          </div>
          {children}
          {footer && <div className="flex items-center justify-center gap-2">{footer}</div>}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
